import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './HomePageGoogleDryer.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
import AllServicesData from '../ServicesPage/AreaData'
// images
import LocationReviewsData from './LocationReviewsData'
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import emailjs from 'emailjs-com';

export default function HomePageGoogleDryer({ locationsMain, CitiePhone, CitiesData }) {
    const location = useLocation()
    const navigate = useNavigate()
    const [response, setResponse] = useState({});
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const url = new URL(window.location.href);

    const fireSmithCall = () => {
        if (typeof window === "undefined") return;
        if (url.searchParams.get("spg") !== "o") return;
        if (typeof window.oaiq !== "function") return;
        const eventName = "smith_dryer_vent_phone_call";
        try {
            window.oaiq("measure", "custom", { type: "custom" }, {
                custom_event_name: eventName,
                event_id: `${eventName}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
            });
        } catch (e) { }
    };

    function sendEmail(e) {
        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    const data = {
        title: "",
        rows: [

            {
                title: "Why choose Smith & Sons Dryer Vent?",
                content: "With 50 years of expertise, we provide professional, reliable dryer vent services, ensuring safety and efficiency in every home."
            },
            {
                title: "What services do you offer?",
                content: "We offer dryer vent cleaning, dryer vent inspection, dryer vent repair, dryer vent installation, exterior vent and lint trap cleaning, and annual maintenance plans for optimal performance and safety."
            },
            {
                title: "How much is a dryer vent inspection?",
                content: "Our dryer vent inspection costs $69. It includes a comprehensive check to identify potential issues."
            },
            {
                title: "Can you clean and repair together?",
                content: "Yes, we offer same-day cleaning and repair services during your appointment if needed."
            },
            {
                title: `Do you provide services surrounding ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}?`,
                content: `Yes, we don't just serve ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}! We cover a wide area, including a 75-mile radius around ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}. Whether you're in nearby towns or surrounding areas, we're here to help.`
            },
            {
                title: "How do I book an appointment?",
                content: `Call us <a href='tel:${CitiePhone}'>${CitiePhone}</a> or fill out the <a href='/book${location.search ? location.search + '&' : '?'}service=dryer'>online form</a> to schedule your visit.`
            },

        ]
    };
    const styles = {
        bgColor: 'white',
        titleTextColor: 'white',
        titleTextSize: '18px',
        rowTitleColor: '#082d49',
        rowTitleTextSize: '21px',
        rowContentColor: '#082d49',
        rowContentTextSize: '16px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "#082d49",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const searchKeyword = `I need from you 32 words about the "${url.searchParams.get('kd')}" how we "Smith & Sons dryer vent " can help our clients with that kind of service, give me that as json file: title 3 words (include in the title words from the keyword, remove null and Smith & Sons chimmney sweep from title)(if no keywords just do for dryer vent sweep) and body`
                const resChat = await fetch(`https://genesis-platforms-8157acd2d107.herokuapp.com/api/GenesisOpenAi_Landing_Pages_Content_Creating`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        prompt: searchKeyword
                    })
                })
                const dataChat = await resChat.json()
                console.log(dataChat.content)
                setResponse(JSON.parse(dataChat.content))
            } catch (error) {
                console.log(error);
            }
        })();
    }, []);

    return (
        <div className="HomePageGoogleDryer" id="homepage">
            <Helmet>
                {/* <!-- TITLE -->  */}
                {/* <!-- Maximum of 65 characters --> */}
                <title>Smith & Sons Dryer Vent | Expert Dryer Vent Cleaning, Inspection & Services | {CitiePhone}</title>
                {/* <!-- Maximum 35 characters --> */}
                <meta name="title" property="title" content="Dryer Vent Cleaning | Expert Dryer Vent Cleaning, Inspection & Services | {CitiePhone}" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Dryer Vent Cleaning | Expert Dryer Vent Cleaning, Inspection & Services | {CitiePhone}" data-react-helmet="true" />
                {/* <!-- META --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="article" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="article" data-react-helmet="true" />
                {/* <!-- Full link to the current webpage address -->  */}
                <meta name="og:url" property="og:url" content="https://www.smithandsonsdryer vent.com/" data-react-helmet="true" />
                {/* <!-- Maximum of 155 characters  --> */}
                <meta name="description" content="Dryer Vent Cleaning provides top-quality dryer vent cleaning, inspections, and repairs to keep your home safe and efficient. Trust our experienced professionals for all your dryer vent service needs." data-react-helmet="true" />
                {/* <!-- Maximum 65 characters --> */}
                <meta name="og:description" property="og:description" content="Dryer Vent Cleaning provides top-quality dryer vent cleaning, inspections, and repairs to keep your home safe and efficient. Trust our experienced professionals for all your dryer vent service needs." data-react-helmet="true" />
                <meta name="og:site_name" property="og:site_name" content="Dryer Vent Cleaning" data-react-helmet="true" />
                <meta name="keywords" content="dryer vent sweep, dryer vent Inspection, Dryer Vent Inspection, Fireplace Inspection, Fireplace Cleaning, Dryer Vent Cleaning, Dryer Vent Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Dryer Vent Inspection, Fireplace Inspection, Fireplace Cleaning, Dryer Vent Cleaning, Dryer Vent Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, dryer vent services, dryer vent service, Dryer Vent Inspection, Fireplace Inspection, Fireplace Cleaning, Dryer Vent Cleaning, Dryer Vent Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Dryer Vent Insulation, Dryer Vent Installation, Dryer Vent Liner Repair, Dryer Vent Pointing, Dryer Vent Rainp Installation, Dryer Vent Repair, Dryer Vent Crown Repair, Dryer Vent Restoration, Dryer Vent Flue Installation, Dryer Vent Flue Repair, ​Dryer Vent Construction, Dryer Vent Vent Installation, Dryer Vent Flashing, Flexible Dryer Vent Liner Installation, Dryer Vent Damper Repair, Dryer Ventp Repair, Fireplace Insulation, Fireplace Installation, Fireplace Liner Repair, Fireplace Pointing, Fireplace Rainp Installation, Fireplace Repair, Fireplace Crown Repair, Fireplace Restoration, Fireplace Flue Installation, Fireplace Flue Repair, Ffireplace Construction, Fireplace Vent Installation, Fireplace Flashing, Flexible fireplace Liner Installation, Fireplace Damper Repair, Fireplacep" data-react-helmet="true" />
            </Helmet>
            {/* MainBanner */}
            <div className="MainBanner">
                <div className="MainBannerLeft">
                    <h1>PREMIUM DRYER VENT SERVICE IN {CitiesData && CitiesData.City ? CitiesData.Full.toUpperCase() : "YOUR AREA"} IS OUR SUPERPOWER</h1>
                    <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> And Surrounding Areas • <span>{url.searchParams.get('kd') ? url.searchParams.get('kd').includes('near') ? url.searchParams.get('kd').replace('near me', '•') : url.searchParams.get('kd') + "," : ""}</span> Dryer Vent Inspections, Repair And Cleaning Near Me</h2>
                    <div className="MainBannerLeftButtons">
                        <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                        <a onClick={() => navigate(`/book${location.search ? location.search + '&' : '?'}service=dryer`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Dryer Vent Cleaning Cleaning Near Me Smith and Sons" /></a>
                    </div>
                    <div className="MainBannerLeftRated">
                        <h3>Rated 4.9 on Google</h3>
                        <span>
                            <h4>4.9</h4>
                            <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                        </span>
                    </div>
                </div>
                <div className="MainBannerRight">
                    <img fetchpriority="low" src={require(`../../ImagesLogos/Banner6LogoDuct.png`)} />
                </div>
            </div>
            {/* MainBanner2Top2 */}

            <div className="MainBanner2Top2" id="about">
                <div className="MainBanner2Top2Bottom">
                    <a>No extra charge for appointments on nights, weekends or holidays</a>
                </div>
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <div className="MainBanner2TopBoxBoxBox">
                            <img src={require(`../../Images/chimneycleaning.png`)} alt="Dryer Vent Cleaning" />
                        </div>
                        <h3>DRYER VENT CLEANING</h3>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <div className="MainBanner2TopBoxBoxBox">
                            <img src={require(`../../Images/chimneyinspection.png`)} alt="Dryer Vent Cleaning" />
                        </div>
                        <h3>DRYER VENT INSPECTION</h3>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <div className="MainBanner2TopBoxBoxBox">
                            <img src={require(`../../Images/chimneymaintenance.png`)} alt="Dryer Vent Cleaning" />
                        </div>
                        <h3>DRYER VENT MAINTENANCE</h3>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <div className="MainBanner2TopBoxBoxBox">
                            <img src={require(`../../Images/chimneyrepair.png`)} alt="Dryer Vent Cleaning" />
                        </div>
                        <h3>DRYER VENT REPAIR</h3>
                    </a>
                </div>

                <div className="MainBanner2TopBoxMainChat">
                    <img src={require(`../../ImagesLogos/Banner3Logo.png`)} />
                    <div className="MainBanner2TopBoxMainChatText">
                        <h4>{response.title}</h4>
                        <h3>{response.body}</h3>
                        <h5>Call us at <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>{CitiePhone}</a> or fill out the <a href={`/book${location.search ? location.search + '&' : '?'}service=dryer`}>online form</a> to schedule your visit.</h5>
                    </div>
                </div>
            </div>

            {/* All home service categories — sub-categories grid */}
            {!location.pathname.startsWith("/local") && (<div className="CategoryBlocks CategoryBlocks-Hide-On-Local">
                {[
                    { key: "chimney", label: "Chimney & Fireplace", href: "/chimney", match: (a) => /chimney|fireplace|creosote|smoke chamber|masonry|tuckpoint|wood stove|gas fireplace|pellet stove|insert/i.test(a.Title) },
                    { key: "airduct", label: "Air Duct", href: "/airduct", match: (a) => /air duct|hvac duct|air vent|coil cleaning|mold removal from air|uv air|anti-microbial duct|indoor air quality|furnace cleaning/i.test(a.Title) },
                    { key: "dryer", label: "Dryer Vent", href: "/dryer", match: (a) => /dryer|lint|bird guard/i.test(a.Title) },
                ].map((cat) => {
                    const subs = AllServicesData.filter(cat.match).slice(0, 8);
                    if (subs.length === 0) return null;
                    return (
                        <div key={cat.key} className={`CategoryBlock CategoryBlock-${cat.key}`}>
                            <div className="CategoryBlockHeader">
                                <h2>{cat.label}</h2>
                                <a href={cat.href}>View {cat.label} Landing →</a>
                            </div>
                            <div className="CategoryBlockGrid">
                                {subs.map((s, i) => (
                                    <a key={i} href={s.Path} className="CategoryBlockItem">
                                        <h3>{s.Title}</h3>
                                        <p>{s.Full}</p>
                                        <span>Learn more →</span>
                                    </a>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>)}

            {/* HomePageGoogleDryerBen */}
            <div className="HomePageGoogleDryerBen">
                <div className="HomePageGoogleDryerBenLEFT">
                    <img fetchpriority="low" src={require(`../../ImagesLogos/Image2Logo.png`)} />
                </div>
                <div className="HomePageGoogleDryerBenRIGHT">
                    <h1>SUPER BENEFITS</h1>
                    <div className="HomePageGoogleDryerBenRIGHTList">
                        <div className="HomePageGoogleDryerBenRIGHTListBox">
                            <img fetchpriority="low" src={require(`../../Images/checklist.png`)} />
                            <h2>
                                Highly Trained & Certified Technicians
                                <h3>- Our Dryer Vent technicians completed more than 6,500 hours of training in 2022</h3>
                                <h3>- Our Technicians complete 45+ hours yearly of weekly skills training</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleDryerBenRIGHTListBox">
                            <img fetchpriority="low" src={require(`../../Images/checklist.png`)} />
                            <h2>
                                Fast Response Time
                                <h3>- 24/7 emergency appointments available</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleDryerBenRIGHTListBox">
                            <img fetchpriority="low" src={require(`../../Images/checklist.png`)} />
                            <h2>
                                Satisfaction Guaranteed
                                <h3>- 6,000+ five-star reviews</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleDryerBenRIGHTListBox">
                            <img fetchpriority="low" src={require(`../../Images/checklist.png`)} />
                            <h2>Fully Licensed & Insured</h2>
                        </div>
                        <div className="HomePageGoogleDryerBenRIGHTListBox">
                            <img fetchpriority="low" src={require(`../../Images/checklist.png`)} />
                            <h2>Friendly Customer Service</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* HomePageGoogleDryerUs */}
            <div className="HomePageGoogleDryerUs">
                <div className="HomePageGoogleDryerUsLeft">
                    <h1>KEEPING YOUR DRYER VENT SAFE</h1>
                    <h2>
                        When you’ve got a dryer vent issue, there’s only one name to call — Smith & Sons Dryer Vent. And it’s not just because of our decades of experience, our stellar reviews, or even our industry awards. It’s because everything we do; we do with your safety and comfort in mind.
                    </h2>
                    <div className="HomePageGoogleDryerUsLeftMoreBox">
                        <h3>HERITAGE</h3>
                        <h4>Proudly serving communities since 2001, built on decades of trusted dryer vent expertise.</h4>
                    </div>
                    <div className="HomePageGoogleDryerUsLeftMoreBox">
                        <h3>RESPONSIVENESS</h3>
                        <h4>Always ready when you need us—rapid service, including same-day and emergency visits, year-round.</h4>
                    </div>
                    <div className="HomePageGoogleDryerUsLeftMoreBox">
                        <h3>EXCELLENCE</h3>
                        <h4>Comprehensive dryer vent services delivered with cutting-edge tools and meticulous attention to detail.</h4>
                    </div>
                    <h6>The team that keeps your family safe and warm with every call.</h6>
                    <div className="MainBannerLeftButtons">
                        <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                        <a onClick={() => navigate(`/book${location.search ? location.search + '&' : '?'}service=dryer`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Dryer Vent Cleaning Cleaning Near Me Smith & Sons Dryer Vent" /></a>
                    </div>
                </div>
                <div className="HomePageGoogRight">
                    <img fetchpriority="low" src={require(`../../Images/dryercleaning.png`)} />
                    <img fetchpriority="low" src={require(`../../Images/dryerlint.png`)} />
                </div>
            </div>
            {/* MainBannerMore */}
            <div className="MainBannerMore">
                <diiv className="MainBannerMoreLeft">
                    <h1>Your Trusted Experts for All Your Dryer Vent Needs!</h1>
                    <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>CALL NOW TO SCHEDULE</a>
                    <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>{CitiePhone}</a>
                </diiv>
                <img fetchpriority="low" src={require(`../../ImagesLogos/Banner5LogoDuct.png`)} />

            </div>
            {/* HomePageGoogleDryerReviews */}
            <div className="HomePageGoogleDryerReviews" id='reviews'>
                <h1>Real Testimonials from Our Valued Client in {CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}</h1>
                <div className="LocationReviewsLsit">
                    <div className="LocationReviewsLsitUnder">
                        {LocationReviewsData.slice(0, 36).map((A, index) =>
                            <div key={index} className="LocationReviewsBox">
                                <div className="LocationReviewsBoxLeft">
                                    {/* <h3>Open Now 24/7 • Top Rated • Same Day Service</h3> */}
                                    <span>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/checklist.png`)}></img>
                                    </span>
                                    <h2><img src={require(`../../Images/GoogleIcons.png`)}></img>Rated 5 By {A.customer_name}</h2>
                                    <h4>{A.review}</h4>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="LocationReviewsLsitShodowR"></div>
                </div>
            </div>
            {/* HomePageGoogleDryerCar */}
            <div className="HomePageGoogleDryerCar">
                <div className="HomePageGoogleDryerCarMain">
                    <div className="HomePageGoogleDryerCarLeft">
                        <img fetchpriority="low" src={require(`../../ImagesLogos/Banner4LogoDuct.png`)} />
                    </div>
                    <div className="HomePageGoogleDryerCarRight">
                        <h1>DRYER VENT CLEANING & REPAIR EXPERT <br /> IN {CitiesData && CitiesData.City ? CitiesData.Full.toUpperCase() : "YOUR AREA"}</h1>
                        <h2>Call For Service:</h2>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>{CitiePhone}</a>
                            <a onClick={() => navigate(`/book${location.search ? location.search + '&' : '?'}service=dryer`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Dryer Vent Cleaning Cleaning Near Me Smith and Sons" /></a>
                        </div>
                    </div>
                </div>
                <div className="HomePageGoogleDryerCarBottom">
                    <a>No extra charge for appointments on nights, weekends or holidays</a>
                </div>
            </div>
            {/* BookAnAppointment */}
            <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
            {/* HomePageGoogleDryerService */}
            <div className="HomePageGoogleDryerService" id="ourservices">
                <div className="MainBanner2Bottom">
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>DRYER VENT CLEANING</h2>
                            <h3>
                                Your Trusted Partner for Dryer Vent Cleaning in {CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}
                                <br />
                                <br />
                                Lint builds up in your dryer ductwork with every load, and a clogged vent is one of the top causes of home fires. Smith & Sons clears the entire run — from the lint trap to the exterior vent hood — using professional rotary brushes and high-powered vacuums. The result is faster drying times, lower energy bills, and a dryer that runs cool and safe.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/dryercleaning2.png`)} alt="Dryer Vent Cleaning Smith and Sons" />
                        </div>
                    </div>
                    <div className="MainBanner2BottomBox">

                        <div className="MainBanner2BottomBoxLeft">
                            <h2>DRYER VENT INSPECTION</h2>
                            <h3>
                                Thorough Dryer Vent Inspections for Peace of Mind
                                <br />
                                <br />
                                Longer drying times, a hot dryer, or a burning smell are warning signs your vent is blocked. Our $69 dryer vent inspection checks the full duct line and exterior vent for lint buildup, crushed or disconnected pipe, and pest nests. You get honest findings and a free estimate up front — so you know exactly what your dryer vent needs before any work begins.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/dryer1.png`)} alt="Dryer Vent Inspection Smith and Sons" />
                        </div>
                    </div>
                </div>
                <div className="MainBanner2Bottom">
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>DRYER VENT REPAIR</h2>
                            <h3>
                                Reliable Dryer Vent Repair Solutions
                                <br />
                                <br />
                                Crushed, kinked, or disconnected ducts trap lint and choke your dryer's airflow. Smith & Sons repairs and replaces damaged dryer ductwork, reconnects loose joints, and swaps out flimsy foil hose for safe, rigid or semi-rigid pipe. We even fix and replace exterior vent hoses and caps — restoring proper airflow so your dryer runs efficiently and safely again.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/dryerventrepair.png`)} alt="Dryer Vent Repair Smith and Sons" />

                        </div>
                    </div>
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>DRYER VENT INSTALLATION</h2>
                            <h3>
                                Professional Dryer Vent Installation
                                <br />
                                <br />
                                Whether you're remodeling, moving a laundry room, or replacing an old failing run, Smith & Sons installs code-compliant dryer venting done right the first time. We route the shortest, smoothest path, use proper rigid ducting, and finish with a quality exterior vent hood and bird guard. Enjoy safer, faster drying with a system built to last.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/dryreinstall.png`)} alt="Dryer Vent Installation Smith and Sons" />

                        </div>
                    </div>

                </div>
                <div className="MainBanner2Bottom">
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>EXTERIOR VENT & LINT TRAP CLEANING</h2>
                            <h3>
                                Exterior Vent & Lint Trap Cleaning
                                <br />
                                <br />
                                Most clogs hide where you can't see them — at the outside vent hood and deep in the lint trap housing. Smith & Sons clears your dryer vent from the outside in, removes packed lint and debris, and installs pest-proof bird guards to stop nests and blockages. It's the detail work that keeps airflow strong and your dryer running safely.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/dryerlint.png`)} alt="Exterior Vent and Lint Trap Cleaning Smith and Sons" />

                        </div>
                    </div>
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>DRYER VENT MAINTENANCE</h2>
                            <h3>
                                Comprehensive Dryer Vent Maintenance Plans
                                <br />
                                <br />
                                Most fire-safety experts recommend cleaning your dryer vent at least once a year. Smith & Sons makes it easy with simple annual maintenance plans that keep your vent clear, your dryer efficient, and your home protected. We'll remind you when you're due and handle the cleaning fast — so lint never has a chance to build back up.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/dryercleaning2.png`)} alt="Dryer Vent Maintenance Smith and Sons" />

                        </div>


                    </div>
                </div>
                <div className="MainBanner2Bottom">
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>AIR DUCT CLEANING</h2>
                            <h3>
                                We Clean Air Ducts Too
                                <br />
                                <br />
                                While we're at your home for the dryer vent, ask about your air ducts. Smith & Sons removes dust, pollen, and allergens from your entire HVAC system so you breathe cleaner air, dust less, and run a more efficient furnace and AC. Bundle air duct and dryer vent cleaning in one visit and save.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/airduct1.png`)} alt="Air Duct Cleaning Smith and Sons" />
                        </div>
                    </div>
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>CHIMNEY SWEEP & FIREPLACE</h2>
                            <h3>
                                Chimney Sweep & Fireplace Services
                                <br />
                                <br />
                                Smith & Sons is also your trusted local chimney company. Our certified sweeps remove dangerous soot and creosote buildup, inspect for blockages and damage, and keep your fireplace burning safely all season. One trusted team for your dryer vent, air ducts, and chimney — book together and save.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/Chimney9.png`)} alt="Chimney Sweep Smith and Sons" />
                        </div>
                    </div>
                </div>
            </div>
            {/* locationsMain */}
            {locationsMain.find(a => a.Phone == CitiePhone) ?
                <div className="HomePageGoogleDryerLocation">
                    <div className="HomePageGoogleDryerLocationLeft">
                        <h1>WHERE YOU'LL FIND SMITH & SONS DRYER VENT</h1>
                        <h2>Smith & Sons Dryer Vent proudly serves families, offering expert dryer vent services. Our skilled technicians are just a short phone call away, ready to assist in neighborhoods throughout <b>{CitiesData && CitiesData.City ? CitiesData.Full.toUpperCase() : "Your Area"}</b>, and the surrounding areas.</h2>
                        {locationsMain.find(a => a.Phone == CitiePhone).Address.map((A, index) =>
                            <div key={index} className="HomePageGoogleDryerLocationLeftBox">
                                <h4>{A.Location1}</h4>
                                <h5>{A.Address1}</h5>
                                <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>{CitiePhone}</a>
                            </div>
                        )}
                    </div>
                    <div className="HomePageGoogleDryerLocationRight">
                        <div className="HomePageGoogleDryerLocationRightMap">

                            <div className="HomePageGoogleDryerLocationRightBorder"></div>
                            <iframe src={locationsMain.find(a => a.Phone == CitiePhone).Map} ></iframe>
                        </div>
                        <div className="HomePageGoogleDryerLocationRightBox">
                            <h4>Smith & Sons Dryer Vent is proud to provide expert dryer vent cleaning, inspection, and repair services to the {CitiesData && CitiesData.City ? CitiesData.City : "Your Area"} area.</h4>
                            <div className="HomePageGoogleDryerLocationRightBoxMenu">
                                <span>
                                    <h2>Manager:</h2>
                                    <h3>Mike Oliver</h3>
                                </span>
                                <span>
                                    <h2>Phone Number:</h2>
                                    <h3>{CitiePhone ? CitiePhone : "866-907-7220"}</h3>
                                </span>
                            </div>

                        </div>
                    </div>
                </div>
                : null}
            {/* HomePageGoogleDryerFAQ */}
            <div className="HomePageGoogleDryerFAQ">
                <h2>GOT QUESTIONS? WE'VE GOT ANSWERS.</h2>
                <h3>Feel Free To Reach Out To Us By Phone. For The Fastest Response, We Are Available By Phone 24/7 And Ready To Provide You With A Complimentary Consultation.</h3>
                <div className="MainBannerLeftButtons">
                    <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                    <a onClick={() => navigate(`/book${location.search ? location.search + '&' : '?'}service=dryer`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Dryer Vent Cleaning Cleaning Near Me Smith and Sons" /></a>
                </div>
                <div className="MainBanner4FaqMore">
                    <Faq
                        data={data}
                        styles={styles}
                        config={config}
                    />
                </div>
            </div>
            {/* HomePageGoogleDryerFooter */}
            <div className="HomePageGoogleDryerFooter" id='footer'>
                <div className="HomePageGoogleDryerFooterTop">
                    <div className="HomePageGoogleDryerFooterTopTitle">
                        <h1>RELIABLE SERVICE, TRUSTED RESULTS</h1>
                        <h2>BOOK YOUR APPOINTMENT NOW!</h2>
                        <h3>With our highly-skilled technicians & upfront pricing, you can trust the local {CitiesData && CitiesData.City ? CitiesData.Full : "Your Area"} experts at Smith & Sons Dryer Vent for 100% satisfaction, guaranteed on all dryer vent sweep services.</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                            <a onClick={() => navigate(`/book${location.search ? location.search + '&' : '?'}service=dryer`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Dryer Vent Cleaning Cleaning Near Me Smith and Sons" /></a>
                        </div>
                    </div>
                    <div className="HomePageGoogleDryerFooterTopImg">
                        <img src={require(`../../ImagesLogos/Banner1Logo.png`)} />
                    </div>
                </div>
                <div className="HomePageGoogleDryerFooterBottom">
                    <div className="HomePageGoogleDryerFooterBottomTop">
                        <img src={require(`../../ImagesLogos/Banner2Logo.png`)} />
                        <p>Copyright © 2024 - Smith & Sons Dryer Vent. All Rights Reserved. Privacy Policy</p>
                        <div className="SiteMapDiv">
                            <h1>Privacy</h1>
                            <a href="/privacy-policy">Privacy Policy</a>
                            <a href="/terms-and-conditions">Terms And Conditions</a>
                        </div>
                    </div>
                    {locationsMain.find(a => a.Phone == CitiePhone) ?
                        <div className="HomePageGoogleDryerFooterMiddle">
                            <h1>OFFICE LOCATIONS</h1>
                            {locationsMain.find(a => a.Phone == CitiePhone).Address.map((A, index) =>
                                <div key={index} className="HomePageGoogleDryerLocationLeftBox">
                                    <h4>{A.Location1}</h4>
                                    <h5>{A.Address1}</h5>
                                    <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>{CitiePhone}</a>
                                </div>
                            )}
                        </div>
                        : null}
                    <div className="HomePageGoogleDryerFooterBottomTop">
                        <h1>CONNECT WITH US</h1>
                        <p>Phone: {CitiePhone}</p>
                        <p>info@smithandsonsdryer vent.com</p>
                        <p>www.smithandsonsdryer vent.com</p>
                    </div>



                </div>
            </div>
        </div>
    )
}

